import moment from 'moment';

export function humanizeDate(rawDate) {
    const m  = new moment(rawDate);
    return m.format('DD-MMM-YYYY');
}

const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ];


export function monthYearFromDate(datestr) {
    const mon = parseInt(datestr.substr(3,2));
    const year = parseInt(datestr.substr(6, 9));
    let month = months[mon-1];
    const monthYear = month.concat(year.toString());
    return monthYear
}

export function periodFromBucket(bucket,collectionType) {

    const year = bucket.substr(0,4);
    const month = bucket.substr(4,2);
    const day = bucket.substr(6,2);
    
    const period = collectionType === 'daily' ? day+"/"+month+"/"+year: day+"/"+month+"/"+year;

    return period;
}